export default class Menu{
  constructor(){
    this.$btnMobile = $("#menu--btn")
    this.$menu = $("#header .menu")
    this.$header = $("#header")
  }

  /**
   * INIT MENU
   */
  init(){
    this.preventDefaultAction();
    this.clickToggleMenuMoile();
    this.accordeonMenuMobile();
    this.resizeWindow();
    this.hoverMenuDesktop();

    if(!this.isMobile()){      
      this.bigMenu();
    }
  }
  
  /**
   * Est on dessous de la media query large ?
   */
  isMobile(){
    return !Foundation.MediaQuery.atLeast('large')
  }

  /**
   * Action à effectuer au resize de la fenêtre
   */
  resizeWindow(){
    $(window).resize(()=>{
      if(this.isMobile()){
        this.setHeightMenuMobile()
      }
    });
  }

  /**
   * Empêche de suivre les liens du premier niveau
   */
  preventDefaultAction(){
    this.$menu.find("li.menu-item-has-children.menu-nolink>a").on("click", (e) => {
      e.preventDefault();
    });
  }

  /**
   * Action au click sur le bouton d'ouverture / fermeture du menu mobile
   */
  clickToggleMenuMoile(){
    this.$btnMobile.on("click", () => {
      if(!this.isMobile()){
        return;
      }
      if(this.$btnMobile.toggleClass("is--open").hasClass("is--open")){
        this.openMenuMobile();
      }
      else{
        this.closeMenuMobile();
      }
    });
  }

  /**
   * Ouverture du menu en mobile
   */
  openMenuMobile(){
    this.setHeightMenuMobile().addClass("is--open")
  }

  /**
   * Fermeture du menu en mobile
   */
  closeMenuMobile(){
    this.$menu.removeClass("is--open")
  }

  /**
   * Définit la hauteur du menu mobile
   */
  setHeightMenuMobile(){
    return this.$menu.height($(window).height() - this.$header.height())
  }

  /**
   * Gestion de l'accordéon du menu mobile
   */
  accordeonMenuMobile(){
    this.$menu.find("li.menu-item-has-children>a").on("click", (e) => {
      if(!this.isMobile()){
        return;
      }
      let $elem = $(e.currentTarget);
      $elem.toggleClass("is--open").next(".sub-menu").slideToggle(200);
    });
  }
  hoverMenuDesktop(){
    this.$menu.find("li.menu-item-has-children>a").hover((ev) => {
      this.toggleClassHover(ev, "in")
    }, (ev) => {
      this.toggleClassHover(ev, "out")
    });
  }
  toggleClassHover(ev, prefix){
    let $elem = $(ev.currentTarget);
    let dir = (ev.pageX - $elem.offset().left - $elem.innerWidth()/2 < 0) ? "left": "right"
    $elem.removeClass("out-left out-right in-left in-right").addClass(`${prefix}-${dir}`)

  }

  bigMenu(){
    $('.big-submenu').each((_index, el) => {
      let bigMenu = $(el).find('.sub-menu');
      bigMenu.append('<div class="row"><span class="background-point"></span></div>');

      $('li',bigMenu).each((_index, el)=>{
        $(el).appendTo(bigMenu.find('.row'));
      });

      let menuPositionLeft = parseInt($('.menu__wrapper').css('marginLeft')) + $('.header__logo').width();
      let windowSize = $(window).width();
      let menuWidth = $('.header__container').width();
      let backgroundPointWidth = (windowSize - menuWidth) / 2;
      
      bigMenu.find('.row').css('paddingLeft',menuPositionLeft);
      bigMenu.find('.background-point').css('width',menuPositionLeft + backgroundPointWidth - 50);
    });
  }
}